//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import CheckboxSection from "@Shared/components/sections/checkbox-section";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CopyApplicationModal",
  components: {
    GenericModal,
    SimpleButton,
    CheckboxSection
  },
  props: {
    applicationStreet: {
      type: String,
      required: true
    },
    currentAddressLength: {
      type: Number,
      default: 0
    },
    documentCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      copyAsCurrentAddress: false,
      copyAsPropertyOwned: false,
      copyAsPreviousAddress: false,
      copyDocuments: false
    };
  },
  computed: {
    propertyAddress() {
      return this.applicationStreet;
    }
  },
  methods: {
    submit() {
      this.$emit("copy-application", {
        copyAsCurrentAddress: this.copyAsCurrentAddress,
        copyAsPropertyOwned: this.copyAsPropertyOwned,
        copyAsPreviousAddress: this.copyAsPreviousAddress,
        copyDocuments: this.copyDocuments
      });
      this.$hideModal();
    },
    closingModal() {
      this.copyAsCurrentAddress = this.copyAsPropertyOwned = this.copyAsPreviousAddress = this.copyDocuments = false;
    }
  }
});